<template>
  <RawLineItemSummarySearchResult
    :total-weight="totalWeight"
    :total-handling-units="totalHandlingUnits"
    :handling-unit-label="handlingUnits"
    :total-linear="showLinear ? totalLinear : undefined"
  />
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { useLineItemsSummary } from '@/composables';
import { LineItem } from '@/model';

import RawLineItemSummarySearchResult from '@/components/search/RawLineItemSummarySearchResult.vue';

const props = defineProps({
  lineItems: {
    type: Array as PropType<LineItem[]>,
    default: () => [],
  },
  showLinear: {
    type: Boolean,
    default: () => false,
  },
});
const { lineItems, showLinear } = toRefs(props);

const { handlingUnits, totalHandlingUnits, totalLinear, totalWeight } =
  useLineItemsSummary(lineItems);
</script>
